<template>
  <div>
    <v-layout row wrap class="ma-0 pa-0">
      <v-flex xs12>
        <div class="px-4 pb-3 my-4">
          <v-btn style="position: absolute; top: 0px; right: 5px" @click="$emit('close')" icon>
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">ประวัติการสั่งซื้อ</div> -->
          <h3 class="headline">History of purchase</h3>

          <!-- :pagination.sync="pagination" -->
          <v-data-table
            :headers="headers"
            :items="dataWarrantyDetail"
            hide-actions
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ props.item.warranty_number }}</td>
                <td>{{ props.item.sku }}</td>
                <td>{{ props.item.name ? props.item.name : '-' }}</td>
                <td>
                  <template v-if="props.item.amounts > 0">
                    {{ props.item.amounts | numberFormat }}
                  </template>
                  <template v-else>-</template>
                </td>
                <td>{{ props.item.types }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'

export default {
  props: ['id'],
  components: {},
  data() {
    return {
      loading: false,
      offset: 0,
      limit: 10,
      headers: [
        { text: 'หมายเลขรับประกันสินค้า', value: 'timestamp', width: '4%', sortable: false },
        { text: 'รหัสรุ่นสินค้า', value: 'product', width: '8%', sortable: false },
        { text: 'สินค้า', value: 'quantity', width: '1%', sortable: false },
        { text: 'ยอดซื้อ', value: 'price', width: '1%', sortable: false },
        { text: 'Gift / Purchase', value: 'shippingcharge', width: '1%', sortable: false }
      ],
      dataWarrantyDetail: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getWarrantyDetails(this.id)
  },
  methods: {
    getWarrantyDetails(id) {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        id: id
      }

      this.loading = true
      api.getLamyWarrantyDetails(data, (err, response) => {
        console.log('response: ', response)
        console.log('err: ', err)
        if (response && response.responsecode == 200) {
          vm.dataWarrantyDetail = response.data
          this.loading = false
        } else {
          console.log(err)
          return
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/lamy/LamyWarrantyDetails.vue